import { useLayoutEffect, useRef } from 'react';

// Aligns an expanded child/detail <table> with its parent DataGrid columns by
// copying the parent header cell widths onto the child via a <colgroup> (mirrors
// the legacy NopChildRows colWidths approach). The child must render the SAME
// number of <td> per row as the parent has columns (incl. the leading expand cell).
export function useAlignedChildTable() {
  const ref = useRef<HTMLTableElement>(null);

  useLayoutEffect(() => {
    const inner = ref.current;
    if (!inner) return;
    // The child table sits inside <td colSpan> of the parent table.
    const outer = inner.parentElement?.closest('table');
    if (!outer) return;

    // Measure the parent header widths ONCE (like legacy). No ResizeObserver —
    // observing the parent while sizing the child creates a feedback loop that keeps
    // widening the table.
    const headerCells = outer.querySelectorAll<HTMLTableCellElement>(':scope > thead > tr > th');
    if (!headerCells.length) return;
    let colgroup = inner.querySelector('colgroup');
    if (!colgroup) {
      colgroup = document.createElement('colgroup');
      inner.insertBefore(colgroup, inner.firstChild);
    }
    colgroup.innerHTML = '';
    headerCells.forEach((th) => {
      const col = document.createElement('col');
      col.style.width = `${th.offsetWidth}px`;
      colgroup!.appendChild(col);
    });
    inner.style.tableLayout = 'fixed';
    inner.style.width = `${outer.offsetWidth}px`;
  }, []);

  return ref;
}
